export class WelfyProjectSetup {
  name: string;
  importCustomer: boolean;
  projectType: number;
}
